export default __webpack_public_path__ + "static/media/starRight.51c46ce4.svg";